import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiMenu, FiX, FiShoppingBag, FiMapPin, FiCalendar, FiMessageCircle, FiGift, FiPhone } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import BilingualText from '../common/BilingualText';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const waLink = "https://wa.me/529841771113";
  const phoneNumber = "+52 984 177 1113";

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 backdrop-blur-md border-b border-mx-green/30 py-2' : 'bg-transparent py-4'}`}>
      
      {/* Urgency Banner */}
      <div className="absolute top-full left-0 w-full bg-mx-red/90 text-white text-[10px] md:text-xs font-bold text-center py-1 tracking-widest uppercase animate-pulse shadow-lg">
        ⚠️ Only 19 slots available today / Solo 19 citas disponibles hoy
      </div>

      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex flex-col items-start group">
          <h1 className="text-2xl md:text-3xl font-serif font-black text-white leading-none">
            EYELASHES<span className="text-mx-green group-hover:text-mx-red transition-colors">MEXICO</span>
          </h1>
          <span className="text-[10px] text-mx-gold tracking-[0.4em] uppercase">Made in Mexico</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/services" className="text-white hover:text-mx-gold transition-colors text-sm font-bold uppercase">
            <BilingualText en="Services" es="Servicios" />
          </Link>
          <Link to="/shop" className="text-white hover:text-mx-gold transition-colors text-sm font-bold uppercase">
            <BilingualText en="Shop" es="Tienda" />
          </Link>
          <Link to="/blog" className="text-white hover:text-mx-gold transition-colors text-sm font-bold uppercase">
            <BilingualText en="Blog" es="Noticias" />
          </Link>
        </nav>

        {/* CTAs */}
        <div className="flex items-center gap-3">
          <a href={`tel:${phoneNumber.replace(/ /g,'')}`} className="hidden lg:flex items-center gap-2 text-white hover:text-mx-gold transition-colors text-xs font-bold tracking-wider mr-2">
            <FiPhone /> {phoneNumber}
          </a>

          <a href={waLink} target="_blank" rel="noreferrer" className="hidden md:flex items-center gap-2 bg-mx-green text-white px-6 py-2 rounded-full font-bold hover:bg-white hover:text-mx-green transition-all shadow-[0_0_15px_rgba(0,104,71,0.5)]">
            <FaWhatsapp className="text-xl" />
            <div className="flex flex-col items-start leading-none">
              <span className="text-xs uppercase">Book Now</span>
              <span className="text-[10px] italic">Reservar</span>
            </div>
          </a>
          
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-white text-3xl hover:text-mx-gold transition-colors">
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>

      {/* Mobile/Hamburger Menu */}
      {menuOpen && (
        <motion.div 
          initial={{ opacity: 0, x: '100%' }}
          animate={{ opacity: 1, x: 0 }}
          className="fixed top-[60px] right-0 h-screen w-[300px] bg-black/95 border-l border-mx-gold/30 p-6 flex flex-col gap-4 shadow-2xl backdrop-blur-xl z-[60]"
        >
          {/* Menu Items linking to WhatsApp */}
          <div className="flex flex-col gap-4 mt-8">
            <a href={`tel:${phoneNumber.replace(/ /g,'')}`} className="menu-link-item text-white">
               <FiPhone className="text-white" /> {phoneNumber}
            </a>
            <div className="h-px bg-white/20 my-2"></div>
            <a href={`${waLink}?text=I need directions / Necesito direcciones`} className="menu-link-item text-white">
              <FiMapPin className="text-mx-red" /> Directions / Direcciones
            </a>
            <a href={`${waLink}?text=I want to book an appointment / Quiero agendar`} className="menu-link-item text-white">
              <FiCalendar className="text-mx-green" /> Book Appointment
            </a>
            <a href={`${waLink}?text=I want a free consultation / Quiero consulta gratis`} className="menu-link-item text-white">
              <FiMessageCircle className="text-mx-gold" /> Free Consultation
            </a>
            <div className="h-px bg-white/10 my-2"></div>
            <a href={`${waLink}?text=Show me new products for sale / Ver nuevos productos`} className="menu-link-item animate-pulse text-white">
              <FiGift className="text-blue-400" /> New Products For Sale
            </a>
            <div className="h-px bg-white/10 my-2"></div>
            <Link to="/services" onClick={() => setMenuOpen(false)} className="menu-link-item text-gray-200">
              Full Service Menu
            </Link>
            <Link to="/blog" onClick={() => setMenuOpen(false)} className="menu-link-item text-gray-200">
              Blog / Noticias
            </Link>
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Header;